<stages-dialog2 #dialog [dialogAriaLabel]="'files.revert.title' | translate">
	<stages-dialog-header />
	<span class="h1" translate="revert"></span>

	@if (revertDataAndInfo$ | async; as revertDataAndInfo) {
		<form [formGroup]="formModel" class="content" name="group" novalidate #formElement>
			<div class="form">
				<stages-attribute-edit
					[attributeTypes]="revertDataAndInfo.metadata"
					[attributes]="revertDataAndInfo.data"
					[form]="formModel"
				>
				</stages-attribute-edit>
			</div>
		</form>
		<footer>
			<div class="buttons">
				<button class="button sm cancel" translate="cancel" (click)="dialog.close()"></button>
				<button class="button sm ok" translate="revert" (click)="submit(revertDataAndInfo.data)"></button>
			</div>
		</footer>
	} @else {
		@if (loadingError$ | async; as error) {
			<span class="h1" translate="error.title"></span>
		}
		<stages-popup-content>
			<stages-loading-error-embeddable [credentialsValid]="true" [loadingError$]="loadingError$" />
		</stages-popup-content>
		<stages-popup-footer [hasCancelButton]="false" [buttons]="buttons" />
	}
</stages-dialog2>

